import { render, staticRenderFns } from "./AngularMomentumViz.vue?vue&type=template&id=6fc04def&scoped=true"
import script from "./AngularMomentumViz.vue?vue&type=script&lang=js"
export * from "./AngularMomentumViz.vue?vue&type=script&lang=js"
import style0 from "./AngularMomentumViz.vue?vue&type=style&index=0&id=6fc04def&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc04def",
  null
  
)

export default component.exports